import React from "react";
import { Grid, Typography, Container, Button, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: "6em",
    width: "100%",
    height: "100",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      alignItems: "center",
      paddingBottom: "8em",
    },
  },
  containerMargin: {
    width: "100%",
    height: "100%",
  },

  containerText: {
    textAlign: "end",
    margin: "auto 0",

    [theme.breakpoints.down("sm")]: {
      margin: "0",
      textAlign: "center",
    },
  },

  carouselTextMargin: {
    marginLeft: "10%",
    width: "100%",
    marginRight: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      textAlign: "center",
      margin: 0,
    },
  },

  carouselImage: {
    objectFit: "cover",
    width: "500px",
    height: "500px",
    borderRadius: "50%",
    [theme.breakpoints.between("sm", "sm")]: {
      width: "400px",
      height: "400px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "300px",
      height: "300px",
    },
  },
  submitButton: {
    width: "110px",
    height: "110px",
    position: "relative",
    left: "420px",
    top: "450px",
    color: "white",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    padding: "20px 40px",
    fontSize: "14px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#0252c2",
    },
    [theme.breakpoints.down("sm")]: {
      width: "60px",
      height: "60px",
      top: "250px",
      left: "80%",
      padding: "10px 20px",
      fontSize: "0.6rem",
      borderRadius: "50%",
    },
  },
  title: {
    textTransform: "capitalize",
  },
}));

const CarouselItem = ({ title, description, imageURL, link }) => {
  const classes = useStyles();

  return (
    <div data-testid="carouselItemTest">
      <Box className={classes.containerMargin}>
        <Grid className={classes.root} container spacing={1}>
          <Grid item className={classes.containerText} sm={5}>
            <Container className={classes.carouselTextMargin}>
              <Typography
                className={classes.title}
                variant={"h1"}
                color="primary"
                gutterBottom
              >
                {title}
              </Typography>
              <Typography color="secondary" variant="subtitle1" gutterBottom>
                {description}
              </Typography>
            </Container>
          </Grid>

          <Grid item sm={7}>
            <Button
              href={link}
              variant={"contained"}
              size={"small"}
              className={classes.submitButton}
            >
              Learn More
            </Button>
            <Container>
              <img
                width="100%"
                height="100%"
                className={`carouselItem ${classes.carouselImage}`}
                src={imageURL}
                alt={title}
              />
            </Container>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CarouselItem;
